import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an oil drop
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OilDropIcon width={12} />
 */
const OilDropIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M37.67,25.57C35.58,15.89,24.01,4,24.01,4S12.42,
            15.89,10.33,25.57C10.11,26.55,10,27.95,10,29c0,
            8.28,6.45,15,14,15c7.56,0,14-6.72,14-15C38,27.95,
            37.9,26.55,37.67,25.57z M24.68,40C18.92,40,14,34.72,
            14,28.21c0-0.82,0.08-1.92,0.25-2.69c0.51-2.45,1.78-5.08,
            3.26-7.52c-0.39,1.03-0.71,2.05-0.92,3.05c-0.21,0.93-0.31,
            2.25-0.31,3.23c0,7.81,5.9,14.15,12.81,14.15c0.3,0,0.6-0.03,
            0.9-0.05C28.42,39.4,26.6,40,24.68,40z`}
        />
    </SvgIcon>
)

OilDropIcon.defaultProps = defaultProps

export { OilDropIcon }
